module.exports = __webpack_public_path__ + "static/media/logo-dark.38d03717.png";